module.exports = __webpack_public_path__ + "img/slide-4-xl.28e395d.webp";